import { fetch } from "../lib/network";
import queryString from "query-string";
import AppSettings from "../config";
import * as Actions from "../actions/crm_statuses";

export const fetchGetCrmStatuses = (dispatch: any) => () => dispatch(Actions.getCrmStatuses());

export const getCrmStatuses = (networkHeaders: any) => (key: any, query: any) =>
  fetch(`${AppSettings.GOGOV_BASE_API_URL}/core/crm/statuses?${queryString.stringify(query)}`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());
